/*
 * PROD-7828 A-22 W6 — Payment emails: query params and request bodies. adapters.test.js pins them to
 * the email enums' published request_fields_read.
 */
import { trim_reason } from '../needs_attention/params';

export const OUTBOX_PAGE_SIZE = 50;

// GET /email/outbox: every filter optional (kind: one email type, e.g. INVOICE_REMINDER); before_id is the previous page's next_before_id (0 = newest).
export const outbox_params = (
  { teacher_uuid, status, kind },
  before_id,
  limit = OUTBOX_PAGE_SIZE
) => ({
  teacher_uuid: teacher_uuid || '',
  status: status || '',
  kind: kind || '',
  before_id: before_id || '',
  limit
});

// POST /email/switch: expected_enabled is what this page showed, so a flip made meanwhile is refused (409).
export const switch_body = (target, shown, reason) => ({
  enabled: target,
  expected_enabled: shown,
  reason: trim_reason(reason)
});
